__turbopack_context__.v({
  "container": "about-panel-module-scss-module__Kt7gGG__container",
  "howToCiteLabel": "about-panel-module-scss-module__Kt7gGG__howToCiteLabel",
});
